'use client';

import { useEffect, useState } from 'react';
import { AD_SETTINGS, AdSlotContext } from '@/lib/adSlots';
import AdHeader from '../AdHeader';

const dateInputClass =
  'w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-900 ' +
  'focus:border-forest-green-500 focus:outline-none focus:ring-1 focus:ring-forest-green-500 ' +
  'dark:border-gray-600 dark:bg-gray-900 dark:text-gray-200 dark:focus:border-forest-green-400';

function toIsoDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function stay22Params(context: Partial<AdSlotContext>): Array<{ name: string; value: string }> {
  const params: Array<{ name: string; value: string }> = [];

  if (context.address) {
    params.push({ name: 'address', value: context.address });
  }
  if (context.lat !== undefined && context.lat !== null) {
    params.push({ name: 'lat', value: String(context.lat) });
  }
  if (context.lng !== undefined && context.lng !== null) {
    params.push({ name: 'lng', value: String(context.lng) });
  }

  params.push({ name: '_token', value: 'csrf-token' });
  params.push({ name: 'aid', value: AD_SETTINGS.stay22Aid });
  params.push({ name: 'campaign', value: AD_SETTINGS.stay22Campaign });

  return params;
}

export default function Stay22Ad({ lat, lng, address }: Partial<AdSlotContext>) {
  const [checkin, setCheckin] = useState('');
  const [checkout, setCheckout] = useState('');

  useEffect(() => {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    setCheckin(toIsoDate(today));
    setCheckout(toIsoDate(tomorrow));
  }, []);

  return (
    <form
      action="https://www.stay22.com/allez/roam"
      method="get"
      target="_blank"
      rel="sponsored nofollow noopener noreferrer"
      className="block"
    >
      {stay22Params({ lat, lng, address }).map(({ name, value }) => (
        <input type="hidden" key={name} name={name} value={value} />
      ))}
      <AdHeader title="Find a hotel nearby" />

      <div className="space-y-4">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Search thousands of hotels, apartments and more in a single place.
        </p>

        <div className="grid grid-cols-2 gap-3">
          <label className="block">
            <span className="mb-1 block text-xs font-medium text-gray-500 dark:text-gray-400">
              Check-in
            </span>
            <input
              type="date"
              name="checkin"
              value={checkin}
              onChange={(event) => setCheckin(event.target.value)}
              className={dateInputClass}
            />
          </label>
          <label className="block">
            <span className="mb-1 block text-xs font-medium text-gray-500 dark:text-gray-400">
              Check-out
            </span>
            <input
              type="date"
              name="checkout"
              value={checkout}
              onChange={(event) => setCheckout(event.target.value)}
              className={dateInputClass}
            />
          </label>
        </div>

        <button
          type="submit"
          className="w-full rounded-lg bg-forest-green-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-forest-green-700"
        >
          Search accommodation
        </button>
      </div>
    </form>
  );
}
